import { ca } from '@cian/analytics';

import { IFavoriteEntity } from '../../../types/results';
import { getAllProducs } from '../../../utils/trackings';

export function trackRemoveAllConfirm(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_all',
    label: '',
    products,
  });
}

export function trackRemoveClick(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click_remove',
    label: '',
    products,
  });
}

export function trackRemoveAllClick() {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click_remove_all',
    category: 'ListingFavorites',
    label: '',
  });
}

export function trackRemoveConfirm(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_from_listing_favorites',
    label: '',
    products,
  });
}

export function trackRemoveFromFolder(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'delete_from_collection',
    label: '',
    products,
  });
}
